Customer.Dashboard ||= {}

class Customer.Dashboard.TicketEventView extends Backbone.View

  className: 'clearfix'
  viewType: 'ticket_event'

  initialize: (options = {}) ->
    @options = options

  findTemplate: (sub_type) ->
    template = JST["backbone/templates/customer/ticket/detail/visible_event_templates/#{sub_type}_event"]

    unless template
      message = "Template for visible event does not exist #{sub_type}"
      console.warn(message)
      jsLogger.fatal(message)
    template

  viewSubType: ->
    @model.get('sub_type')

  render: ->
    _visible_event = @model.toJSON()
    @template = @findTemplate(_.str.underscored(_visible_event.event_type))
    if  !_visible_event.description &&  _visible_event.event_type == 'Webchat finalized'
      _visible_event_text = _visible_event.user_full_name + " #{I18n.t("customer.dashboard.conversations.webchat_messages.closed_webchat")}"
    else if  _visible_event.event_type == 'Ticket cut'
      @template = JST["backbone/templates/customer/ticket/detail/visible_event_templates/ticket_cut_event"]
      _visible_event_text = " #{I18n.t("customer.dashboard.conversations.ticket_cut")}"
      _target_text = " #{I18n.t("customer.dashboard.conversations.go_to_ticket")}"
    else
      _visible_event_text = "#{I18n.t(_visible_event.description)}"
    event_date = _visible_event.event_date
    @$el.html(@template(event_text: _visible_event_text, event_date: event_date, target_text: _target_text, ticket_id: _visible_event.ticket_id  ))
    @

  removeReplyButton: ->
    # do nothing

  removeCutTicketButton: ->
    # do nothing

  _isLastOngoingSurveyInteraction: (model) ->
    false

  externalIdClass: ->
    ''
